import { BlogPost, Category } from "@/types/blog";

const API_BASEURL = import.meta.env.VITE_API_BASEURL.replace(/\/+$/, "");

export const fetchCachedBlogsCount = async() => {
    const response = await fetch (
      (`${API_BASEURL}/api/v1/blog/cached-post-count`)
    )

    if (!response.ok) throw new Error('Failed to fetch total post count')

    const data = await response.json()
    return await data
}

export const fetchBlogsCount = async (categoryId?: string) => {
  const endpoint = categoryId && categoryId !== 'All'
    ? `${API_BASEURL}/api/v1/blog/posts/count?categoryId=${categoryId}`
    : `${API_BASEURL}/api/v1/blog/posts/count`;

  const response = await fetch(endpoint);

  if (!response.ok) {
    throw new Error('Failed to fetch post count');
  }

  const data = await response.json();
  return data; // { totalPosts: number }
}

export const fetchAllBlogs = async (offset = 0, limit = 10,  lang = "en"): Promise<BlogPost[]> => {
  const response = await fetch(
    `${API_BASEURL}/api/v1/blog/posts?offset=${offset}&limit=${limit}&lang=${lang}`
  );
  if (!response.ok) throw new Error("Failed to fetch blogs");
  return await response.json();
}

export const fetchBlogBySlug = async (
  slug: string,
  lang = "en"
): Promise<BlogPost | null> => {
  const response = await fetch(`${API_BASEURL}/api/v1/blog/posts/${slug}?lang=${lang}`);
  if (!response.ok) throw new Error("Blog not found");
  return await response.json();
}

export const fetchBlogsByCategoryId = async (
  categoryId: string,
  offset = 0,
  limit = 10,
  lang = "en"
): Promise<BlogPost[]> => {
  const response = await fetch(
    `${API_BASEURL}/api/v1/blog/categories/${categoryId}/posts?offset=${offset}&limit=${limit}&lang=${lang}`
  );
  if (!response.ok) throw new Error("Failed to fetch blogs by category");
  return await response.json();
}

export const fetchCategories = async (lang = "en"): Promise<Category[]> => {
  const response = await fetch(`${API_BASEURL}/api/v1/blog/categories?lang=${lang}`);
  if (!response.ok) throw new Error("Failed to fetch categories");
  return await response.json();
}
